module.exports = __webpack_public_path__ + "img/down_piano_succeed.1df91df3.png";